import React from "react";
import { backToInflightIco, logoYellow } from "../Assets/images/imagesExport";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";

const Sidebar = ({ tableFor }) => {
  return (
    <div className="w-[5%] flex flex-col justify-between items-center border h-full py-10">
      <img className=" w-24 mx-auto" src={logoYellow} alt="" srcset="" />
      <Tooltip placement="top" arrow title="Goto Inflight  ">
        <Link target="_blank" to="https://inflight.live/">
          <button className="active:border active:border-blue-200 text-white font-bold py-1 px-2 rounded mx-auto">
            <img className="w-10" src={backToInflightIco} alt="" srcset="" />
          </button>
        </Link>
      </Tooltip>
    </div>
  );
};

export default Sidebar;
